function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}

module.exports = _isTransformer;